import logo from './logo.svg';
import './App.css';
import Amap from './Amap'; // 导入 Amap 组件
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import ConfigInput from './ConfigInput';

function App() {
  return (
    <Router>
            <Routes>
                <Route path="/" element={<ConfigInput />} /> {/* 使用 element 属性 */}
                <Route path="/map" element={<Amap />} /> {/* 使用 element 属性 */}
            </Routes>
    </Router>
    // <div className="App" >
    //   {/* <h1>React with Amap</h1> */}
    //   <Amap /> {/* 使用高德地图组件 */}
    // </div> 
  );
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
